export const insertAt = <T>(array: T[], index: number, ...items: T[]) => {
  // Array.prototype.splice mutates the array, insertAt follows the immutability principle to make working with React easier
  const copy = [...array];
  copy.splice(index, 0, ...items);
  return copy;
};

export const sort = <T>(array: T[], comparator: (a: T, b: T) => number) => {
  return [...array].sort(comparator);
};

export const isSorted = <T>(array: T[], comparator: (a: T, b: T) => number) => {
  return array.every((_, index) => {
    if (index === 0) {
      return true;
    }
    return comparator(array[index - 1], array[index]) <= 0;
  });
};
